const ONE_PIECE_MODES = new Set(["dropshipping", "one-piece", "1-piece"]);

export function normalizeExplicitPricingMode(pricingMode, dropshippingLabel = "dropshipping") {
  if (!pricingMode) return null;
  const mode = String(pricingMode).toLowerCase().trim();
  if (mode === "wholesale") return "wholesale";
  if (ONE_PIECE_MODES.has(mode)) return dropshippingLabel;
  return null;
}

export function getProductIdFromOrderDetail(item) {
  if (!item) return "";
  return (
    item?.product?._id?.toString?.() ||
    item?.product?.toString?.() ||
    item?.productId?._id?.toString?.() ||
    (item?.productId && typeof item.productId === "object"
      ? String(item.productId._id || item.productId)
      : item?.productId?.toString?.()) ||
    ""
  );
}

export function getOrderItemPricingMode(
  item,
  {
    orderBreakdown = [],
    orderType = null,
    isManualOrder = false,
    dropshippingLabel = "dropshipping",
  } = {}
) {
  if (isManualOrder && orderType) {
    const orderTypeLower = String(orderType).toLowerCase();
    if (orderTypeLower === "wholesale") return "wholesale";
    if (ONE_PIECE_MODES.has(orderTypeLower)) return dropshippingLabel;
  }

  const explicitMode = normalizeExplicitPricingMode(item?.pricingMode, dropshippingLabel);
  if (explicitMode) return explicitMode;

  const wholesaleBreakdownMap = new Map();
  if (Array.isArray(orderBreakdown)) {
    for (const breakdownItem of orderBreakdown) {
      if (
        breakdownItem?.pricingMode === "wholesale" &&
        breakdownItem?.productId &&
        breakdownItem?.breakdown?.[0]?.FBP
      ) {
        wholesaleBreakdownMap.set(breakdownItem.productId.toString(), true);
      }
    }
  }

  const productId = getProductIdFromOrderDetail(item);
  if (!wholesaleBreakdownMap.has(productId)) {
    return dropshippingLabel;
  }

  const variant = item?.variant;
  let variantPrice = 0;
  if (variant?.finalPrice != null && Number(variant.finalPrice) > 0) {
    variantPrice = Number(variant.finalPrice);
  } else {
    variantPrice = Number(variant?.breakdown?.FBP ?? variant?.breakdown?.fbp) || 0;
  }

  const consumerPrice = Number(item?.consumerPrice);
  if (variantPrice > 0 && Math.abs(variantPrice - consumerPrice) < 0.01) {
    return dropshippingLabel;
  }

  return "wholesale";
}
